const $ = require('jquery');
const toastService = require('./toast');
const loader = require('./loader');
const premiumConfig = window.PREMIUM;
const user = window.USER;
const upgradeProgress = window.UPGRADE_PREMIUM;
const premiumPlanYearly = window.PREMIUM_PLAN_YEAR;
const premiumPlan6Months = window.PREMIUM_PLAN_SIX_MONTH;
const stripeClientSecret = window.STRIPE_INTENT_SECRET;

var premiumPlan = '';
const price_premium_yearly = premiumPlanYearly.amount.toString().substr(0,3)+'kr';
const price_premium_6month = premiumPlan6Months.amount.toString().substr(0,3)+'kr';
const selector_premium = $('#payment-modal');
var selector_price_number = selector_premium.find('.price-number');
var selector_total_number = selector_premium.find('.total-number');
var selector_introduce_subcription = selector_premium.find('.introduce-subcription');

function setPremiumYearly (){
    selector_price_number.text(price_premium_yearly);
    selector_total_number.text(price_premium_yearly);
    selector_introduce_subcription.text('Premiummedlemskap -12 månader');
    premiumPlan = premiumPlanYearly;
}
function setPremiumSixMonth (){
    selector_price_number.text(price_premium_6month);
    selector_total_number.text(price_premium_6month);
    premiumPlan = premiumPlan6Months;
    selector_introduce_subcription.text('Premiummedlemskap -6 månader');
}
setPremiumYearly();

$('.option-subcripntion input[name=subcription-checkout]').on('change', async function () {
    $(this).closest('#payment-modal').find('.discount-info').hide();
    $(this).closest('#payment-modal').find('.total-info').hide();
    $(this).closest('#payment-modal').find('#loading-update-price').show();
    if (this.value === 'checked_yearly'){
        let payment_modal = $(this).closest('#payment-modal');
        let discount = payment_modal.find('.discount-input input').val();
        if(discount !== '') {
            setPremiumYearly();
            try {
                await checkDiscount(discount);
            } catch (e) {

            }
            $(this).closest('#payment-modal').find('.discount-info').show();
            $(this).closest('#payment-modal').find('.total-info').show();
            $(this).closest('#payment-modal').find('#loading-update-price').hide();
        }
        else {
            setPremiumYearly();
            $(this).closest('#payment-modal').find('.discount-info').show();
            $(this).closest('#payment-modal').find('.total-info').show();
            $(this).closest('#payment-modal').find('#loading-update-price').hide();
        }
    }
    else if (this.value === 'checked_six_month') {
        var payment_modal = $(this).closest('#payment-modal');
        var discount = payment_modal.find('.discount-input input').val();
        if(discount !== '') {
            setPremiumSixMonth();
            try {
                await checkDiscount(discount);
            } catch (e) {

            }
            $(this).closest('#payment-modal').find('.discount-info').show();
            $(this).closest('#payment-modal').find('.total-info').show();
            $(this).closest('#payment-modal').find('#loading-update-price').hide();
        }
        else {
            setPremiumSixMonth();
            $(this).closest('#payment-modal').find('.discount-info').show();
            $(this).closest('#payment-modal').find('.total-info').show();
            $(this).closest('#payment-modal').find('#loading-update-price').hide();
        }
    }
});


if (upgradeProgress && upgradeProgress.step != 0) {
    loader.show();
    setTimeout(() => {
        idfyResult(upgradeProgress.idfyVerified, upgradeProgress.idfyReason);
        loader.hide();
    }, 100);
}

let IS_PREMEUM_ACCOUNT = user.premium;

window.idfyResult = function(verified, reason) {
    if (verified) {
            $('#payment-modal').modal({
                keyboard: false,
                backdrop: 'static',
                show: true,
            });
    } else {
        if (reason) {
            toastService.error('', reason);
        }
    }
};
$('body').on('click', '[data-action="start-upgrade-premium"]', function(e) {
    if (IS_PREMEUM_ACCOUNT) return;

    e.preventDefault();

    const $this = $(this);
    if ($this.hasClass('processing')) {
        return;
    }
    // $this.removeClass('not-processing').addClass('processing');

    $.ajax(premiumConfig.url.idfyStart, {
        data: {
            initURL: window.location.href
        },
        success: function(res) {
            if (res.verified) {
                window.idfyResult(res.verified, '');
            } else {
                // const strWindowFeatures = "location=yes,height=570,width=520,top=20%,left=20%,scrollbars=yes,status=yes,centerscreen=yes";
                // const URL = res.url;
                // const win = window.open(URL, "_blank", strWindowFeatures);
                // win.focus();
                window.location.href = res.url;
            }
        },
        error: function(err) {
            console.error('error', err);
        }
    });
});

// window.addEventListener('popstate', function() {
//     stripeHandler.close();
// });

// $('#upgrade-premium-modal').on('hide.bs.modal', function (e) {
//     location.reload();
// });
const stripe = Stripe(window.STRIPE_KEY);
const elements = stripe.elements();
var style = {
    base: {
        color: '#32325d',
        lineHeight: '18px',
        height: '18px',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        //fontSize: '16px',
        '::placeholder': {
            color: 'black'
        }
    },
    invalid: {
        color: '#FF0000',
        iconColor: '#FF0000'
    }
};
const cardNumber = elements.create('cardNumber', {
    placeholder: '',
    style:style
});
cardNumber.mount('#card-number');
const cardCvc = elements.create('cardCvc',{
    style:style,
    placeholder: 'XXX'
});
cardCvc.mount('#card-cvc');
const cardExpiry = elements.create('cardExpiry',{
    style:style
});
cardExpiry.mount('#card-expiry');
function CardError(card_element){
    card_element.addEventListener('change', function(event) {
        if(card_element == cardNumber) {
            var displayError = $('#card-number-errors');
            if (event.error) {
                displayError.text('Ditt kortnummer är ogiltigt.');
            } else {
                displayError.text('');
            }
        }
        else {
            var displayError = $('#card-expiry-errors');
            if (event.error) {
                if(card_element == cardExpiry){
                    displayError.text('Utgångsdatum är ogiltigt.');
                }
                else{
                    displayError.text('Ditt korts säkerhetskod är ofullständigt.');
                }
            } else {
                displayError.text('');
            }
        }
    });
}
CardError(cardNumber);
CardError(cardCvc);
CardError(cardExpiry);
const form = document.getElementById('payment-form');

var submitPurchase = false;
var buttonPurchase = $('#payment-form').find('.purchase-btn').find('.fa-spinner');
var errorElement = $('#card-errors');

form.addEventListener('submit', async function(event) {
    errorElement.text('');
    buttonPurchase.removeClass('not-processing');
    event.preventDefault();
    if (submitPurchase) return;
    submitPurchase = true;

    const discount = $('#payment-modal').find('.discount-input input').val();
    if (discount != '') {
        try {
            await checkDiscount(discount);
        } catch (e) {
            submitPurchase = false;
            buttonPurchase.addClass('not-processing');
            errorElement.text('Ogiltig rabattkod!');
            return;
        }
    } else {
        const payment_modal = $('#payment-modal');
        payment_modal.find('.discount-input input').removeClass('active');
        payment_modal.find('.error-discount').html('');
        payment_modal.find('.success-discount').html('');
    }

    const {paymentMethod, error} = await stripe.createPaymentMethod({
        type: 'card',
        card: cardNumber,
    });

    if (error) {
        errorElement.text(error.message);
        submitPurchase = false;
        buttonPurchase.addClass('not-processing');

        return;
    }

    // const token = setupIntent.payment_method;
    const token = paymentMethod.id;

    try {
        await stripeTokenHandler(token, discount, cardNumber, paymentMethod);

        IS_PREMEUM_ACCOUNT = true;
        const content = $('#upgrade-premium-modal').find('.content');
        content.find('.toPremium').removeClass('active');
        content.find('.success-premium').addClass('active');
        IS_PREMEUM_ACCOUNT = false;
        toastService.success('', 'Grattis! Du är nu premiummedlem.');
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'become-premium'
        });
        window.location.reload();

    } catch (error) {
        if(error.message) {
            errorElement.text(error.message);
        }
        // var content = $('#upgrade-premium-modal').find('.content');
        // content.find('.toPremium').removeClass('active');
        // content.find('.error-premium').addClass('active');
        // IS_PREMEUM_ACCOUNT = false;
        // window.location.reload();
        errorElement.text(error.message);
        submitPurchase = false;
        buttonPurchase.addClass('not-processing');
    }

    /*stripe.createToken(cardNumber).then(function(result) {
        if (result.error) {
            errorElement.text(result.error.message);
            submitPurchase = false;
            buttonPurchase.addClass('not-processing');
        } else {
            var discount = $('#payment-modal').find('.discount-input input').val();
            if(discount != ''){
                checkDiscount(discount, () =>{
                    stripeTokenHandler(result.token, discount);
                });
            }else{
                stripeTokenHandler(result.token, discount);
            }
        }
    });*/
});

async function stripeTokenHandler(token, discount, card, paymentMethod) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type:'POST',
            url: premiumConfig.url.stripePay,
            data: {
                stripeToken:token,
                plan: premiumPlan.id,
                discount:discount,
                option_plan: premiumPlan.interval
            },
            dataType:'json',
            success: async function(data) {
                if (data.require_action) {
                    const {paymentIntent, error} = await stripe.confirmCardPayment(data.client_secret, {
                        payment_method: paymentMethod.id
                    });

                    if (error) {
                        reject(error);
                    } else {
                        resolve({success: true, confirmed: true, paymentIntent});
                    }
                    return;
                }
                resolve(data);




            },
            error: function (error) {
                reject(error.responseJSON);
            }
        })
    });
}
$('#add-discount').click(async function () {
    var payment_modal = $(this).closest('#payment-modal');
    var discount = payment_modal.find('.discount-input input').val();
    if(discount != '') {
        // await checkDiscount(discount);
        try {
            await checkDiscount(discount);
        } catch (e) {

        }
    }
    else{
        payment_modal.find('.discount-input input').addClass('active');
        payment_modal.find('.success-discount').html('');
        payment_modal.find('.error-discount').html('');

        const total = payment_modal.find('.price-number').first().html().substr(0,3);
        payment_modal.find('.discount-number').html('0kr');
        payment_modal.find('.total-number').html(`${total}kr`);
    }
});
async function checkDiscount(discount, callback){
    return new Promise((resolve, reject) => {
        const payment_modal = $('#payment-modal');
        $.ajax({
            type:'post',
            url:'/premium/stripeCoupon',
            data: {
                discount: discount
            },
            dataType: 'json',
            success:function(data){
                payment_modal.find('.discount-input input').removeClass('active');
                payment_modal.find('.error-discount').html('');
                payment_modal.find('.success-discount').html('Giltig rabattkod');
                const total = payment_modal.find('.price-number').first().html().substr(0,3);
                payment_modal.find('.discount-number').html(Math.round((data.percent_off/100) * total * 100)/100 + 'kr');
                payment_modal.find('.total-number').html((total - (data.percent_off/100 * total)) + 'kr');

                $('#payment-modal').find('.discount-info').show();
                $('#payment-modal').find('.total-info').show();
                $('#payment-modal').find('#loading-update-price').hide();

                resolve(data);
            },
            error:function(data){
                payment_modal.find('.discount-input input').addClass('active');
                payment_modal.find('.discount-input input').addClass('was-validated');
                payment_modal.find('.success-discount').html('');
                payment_modal.find('.error-discount').html('Ogiltig rabattkod: ' + discount);
                //payment_modal.find('.price-number').html(price_number);

                const total = payment_modal.find('.price-number').first().html().substr(0,3);
                payment_modal.find('.discount-number').html('0kr');
                payment_modal.find('.total-number').html(`${total}kr`);

                reject(data);
            }
        });
    });
}


// For change card in payment
if(IS_PREMEUM_ACCOUNT) {
    (function() {
        const stripe = Stripe(window.STRIPE_KEY);
        const elements = stripe.elements();

        const stylePaymentCard = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#FF0000',
                iconColor: '#FF0000'
            }
        };
        const card = elements.create('card', {
            hidePostalCode: true,
            style: stylePaymentCard
        });

        card.mount('#card-element');
        card.addEventListener('change', function(event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                if(event.error.code == "incomplete_number") {
                    displayError.textContent = 'Ditt kortnummer är ofullständigt.';
                }
                if(event.error.code == "invalid_number") {
                    displayError.textContent = 'Ditt kortnummer är ogiltigt.';
                }
                if(event.error.code == "invalid_expiry_year_past") {
                    displayError.textContent = 'Utgångsdatum är ogiltigt.';
                }
                if(event.error.code == "incomplete_cvc") {
                    displayError.textContent = 'Ditt korts säkerhetskod är ofullständigt.';
                }
            } else {
                displayError.textContent = '';
            }
        });

        const form = document.getElementById('update-payment-form');
        form.addEventListener('submit', async function(event) {
            event.preventDefault();
            //TODO: reimplement this one
            const { setupIntent, error } = await stripe.handleCardSetup(stripeClientSecret, card);
            if (error) {
                const errorElement = document.getElementById('card-errors');
                errorElement.textContent = error.message;
            } else {
                updateCardStripeTokenHandler(setupIntent.payment_method);
            }

            // stripe.createToken(card).then(function(result) {
            //     if (result.error) {
            //         var errorElement = document.getElementById('card-errors');
            //         errorElement.textContent = result.error.message;
            //     } else {
            //         updateCardStripeTokenHandler(result.token);
            //     }
            // });
        });

        function updateCardStripeTokenHandler(token) {
            $.ajax({
                type:'post',
                url:'/premium/updatePayment',
                data:{
                    stripeToken: token
                },
                dataType:'json',
                success:function (data) {
                    const card = data.card;
                    $('.update-payment-form').removeClass('active');
                    $('.update-info-card').addClass('active');
                    $('#card-number-info').val('**** **** **** ' + card.last4);
                    $('#card-expiry-info').val(card.exp_month + '/' + card.exp_year);
                }
            });
        }

    })();
}

$('#update-card').click(function (e) {
    e.preventDefault();
    var $content = $(this).closest('.modal-body').find('.content');
    $content.find('.update-payment-form').addClass('active');
    $content.find('.update-info-card').removeClass('active');
});
$('#check-recurring').change(function (e) {
    e.preventDefault();
    var check = ($('#check-recurring').prop('checked') == true) ? "checked" : "";
    $.ajax({
        type:'post',
        url:'/premium/checkRecurring',
        data:{
            check:check
        }
    });
});
$('#end-premium').click(function (e) {
    e.preventDefault();
    $('#end-premium-modal').modal('show');

});
$('#save-end-premium').on('click', function (e) {
    $.ajax({
        type: 'post',
        url:'/premium/endPremium',
        success: function (data) {
            var message = data['message'];
            $('#end-premium-modal').modal('hide');
            $('#edit-owner-modal').modal('hide');
            $('#edit-borrower-modal').modal('hide');
            toastService.success('success', message);
        }
    })
});


// if ($('#checked_yearly').is(':checked')){
//     console.log('1');
// }
// else if ($('#checked_six_month').is(':checked')){
//     console.log('2');
// }



// WEBPACK FOOTER //
// ./resources/assets/js/premium.js